import { z } from 'zod';
import { PropertyAddressSchema } from '~/lib/addresses/schema';

import { routing } from '~/lib/navigation';

const WorkspaceSchema = z.object({ accountId: z.uuid() });
const PropertySchema = WorkspaceSchema.extend({ propertyId: z.uuid() });

export const SavePropertySchema = WorkspaceSchema.extend({
  propertyAddress: PropertyAddressSchema.optional(),
  parcel: z
    .object({
      block: z.string().regex(/^[0-9A-Z]{1,6}$/i),
      lot: z.string().regex(/^[0-9A-Z]{1,6}$/i),
    })
    .optional(),
  address: z.string().trim().min(1).max(400),
  portfolioId: z.uuid().optional(),
  locale: z
    .string()
    .refine((value) => routing.locales.includes(value))
    .optional(),
}).refine((v) => Boolean(v.propertyAddress) !== Boolean(v.parcel), {
  message: 'Choose a property address',
});

export const CreatePortfolioSchema = WorkspaceSchema.extend({
  name: z.string().trim().min(1, 'Enter a portfolio name').max(80),
});

export const RenamePortfolioSchema = CreatePortfolioSchema.extend({ portfolioId: z.uuid() });
export const DeletePortfolioSchema = WorkspaceSchema.extend({ portfolioId: z.uuid() });
export const RenamePropertySchema = PropertySchema.extend({
  nickname: z
    .string()
    .trim()
    .max(80)
    .refine(
      (value) =>
        Array.from(value).every(
          (character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127,
        ),
      'Use a single line for the nickname',
    ),
});
export const DeletePropertySchema = PropertySchema;

export const SetMonitoringSchema = PropertySchema.extend({
  monitoringEnabled: z.boolean(),
});

export const PositionPortfolioSchema = WorkspaceSchema.extend({
  portfolioId: z.uuid(),
  beforeId: z.uuid().nullable(),
});
export const PositionPropertySchema = PropertySchema.extend({
  portfolioId: z.uuid(),
  expectedPortfolioId: z.uuid(),
  beforeId: z.uuid().nullable(),
});

export const SetPersonalMonitoringSchema = WorkspaceSchema.extend({
  targetId: z.uuid(),
  targetType: z.enum(['property', 'portfolio']),
  monitoringEnabled: z.boolean(),
});
